export default {"src":"/_next/static/media/is.066388a9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};